// DB-lag for standard portal-seksjoner (Supabase-tabell `portal_sections`).
// Repo-seksjonene (sections.js) er "fasit": de seedes inn ved første gangs bruk
// og brukes som fallback hvis DB feiler, samt som mal for "tilbakestill".

import { supabase } from '../../supabase';
import { STANDARD_SECTIONS } from './sections';

const DEFAULT_ROWS = STANDARD_SECTIONS.map((s, i) => ({
  key: s.key, label: s.label, html: s.html, sort_order: i,
  enabled_default: s.enabledDefault !== false, is_standard: true,
}));
const DEFAULT_BY_KEY = Object.fromEntries(DEFAULT_ROWS.map(r => [r.key, r]));

const asLib = rows => rows.map(r => ({
  key: r.key, label: r.label, html: r.html, html_en: r.html_en || "",
  enabledDefault: r.enabled_default !== false, sort_order: r.sort_order ?? 0,
}));

export function defaultHtml(key) { return DEFAULT_BY_KEY[key]?.html || ""; }

// Hent seksjoner fra DB. Seeder fra repo ved tom tabell, faller tilbake til repo ved feil.
export async function loadSections() {
  try {
    let { data, error } = await supabase.from('portal_sections').select('*').order('sort_order', { ascending:true });
    if (error) throw error;
    if (!data || data.length === 0) {
      await supabase.from('portal_sections').upsert(DEFAULT_ROWS, { onConflict:'key', ignoreDuplicates:true });
      ({ data } = await supabase.from('portal_sections').select('*').order('sort_order', { ascending:true }));
    }
    if (data && data.length) return asLib(data);
  } catch (e) { /* faller tilbake under */ }
  return asLib(DEFAULT_ROWS);
}

export function toSectionMap(sections) {
  return Object.fromEntries(sections.map(s => [s.key, { label:s.label, html:s.html, html_en:s.html_en || "" }]));
}

export async function saveSection(key, patch) {
  const { error } = await supabase.from('portal_sections')
    .update({ ...patch, updated_at: new Date().toISOString() })
    .eq('key', key);
  return error;
}
